import React from "react";
import cs from "classnames";

import { MAX_QUANTITY, MIN_QUANTITY } from "./productStoreCart";
import { Icon } from "../shared/Icon/Icon";

import "./QuantityStepper.scss";

interface Props {
  /** What is counted, for screen readers, e.g. the product name. */
  label: string;
  value: number;
  className?: string;
  onChange: (value: number) => void;
}

export const QuantityStepper = ({
  label,
  value,
  className,
  onChange,
}: Props) => (
  <div
    className={cs("QuantityStepper", className)}
    role="group"
    aria-label={`Quantity of ${label}`}
  >
    <button
      type="button"
      aria-label="Decrease quantity"
      disabled={value <= MIN_QUANTITY}
      onClick={() => onChange(value - 1)}
    >
      <Icon icon="minus" />
    </button>
    <span aria-live="polite" aria-atomic="true">
      {value}
    </span>
    <button
      type="button"
      aria-label="Increase quantity"
      disabled={value >= MAX_QUANTITY}
      onClick={() => onChange(value + 1)}
    >
      <Icon icon="plus-icon-bordered" />
    </button>
  </div>
);
